import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enJs from '@/locales/en';
import esJs from '@/locales/es';
import caJs from '@/locales/ca';

Vue.use(VueI18n);

const supportedLangs = ['es', 'en'];
const pathLang = window.location.pathname.split('/')[1];
const defaultLang = 'ca';

const locale = supportedLangs.includes(pathLang) ? pathLang : defaultLang;

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'es',
  messages: {
    ca: caJs,
    es: esJs,
    en: enJs
  },
  silentTranslationWarn: true
});

export default i18n;
